import {Nullable} from '../../app/TypeHelpers'
import moment from 'moment'

export class NotificationReceiver {
    familyName: string
    firstName: string
    termStartDate: Nullable<moment.Moment>
    termEndDate: Nullable<moment.Moment>
    abolitionDatetime: Nullable<moment.Moment>
    loginAvailability: string
    hasMailAddress: boolean

    constructor(
        familyName: string,
        firstName: string,
        termStartDate: Nullable<moment.Moment>,
        termEndDate: Nullable<moment.Moment>,
        abolitionDatetime: Nullable<moment.Moment>,
        loginAvailability: string,
        hasMailAddress: boolean,
    ) {
        this.familyName = familyName
        this.firstName = firstName
        this.termStartDate = termStartDate
        this.termEndDate = termEndDate
        this.abolitionDatetime = abolitionDatetime
        this.loginAvailability = loginAvailability
        this.hasMailAddress = hasMailAddress
    }

    static from(json: any): NotificationReceiver {
        return new NotificationReceiver(
            json.familyName,
            json.firstName,
            json.termStartDate === null ? null : moment(json.termStartDate),
            json.termEndDate === null ? null : moment(json.termEndDate),
            json.abolitionDatetime === null ? null : moment(json.abolitionDatetime),
            json.loginAvailability,
            json.hasMailAddress,
        )
    }
}
